<template>
<div>
<loading :active.sync="isLoading"></loading>
<Header />
<component v-on:transView="transView" v-bind:is="currentView" />
<Footer />
</div>
</template>

<script>
import Footer from './footer'
import Form from './form'
import Header from './header'
import Loading from 'vue-loading-overlay'
import RegistrationEmailInput from './registration_email/input'
import RegistrationEmailThanks from './registration_email/thanks'

export default {
  data: function () {
    return {
      currentView: 'RegistrationEmailInput',
      isLoading: false,
      form: {}
    }
  },
  mixins: [Form],
  components: {
    Footer,
    Header,
    Loading,
    RegistrationEmailInput,
    RegistrationEmailThanks
  }
}
</script>
